import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'pageCountArray'})
export class PageCountArray implements PipeTransform {
  transform(value, args:string[]) : any {
    let res = [];
    if(value==null)
      return res;
    for (let i = 1; i <= value; i++) {
        res.push(i);
      }
      return res;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/pipes/PageCountArray.pipe.ts